(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ee-collection-size-chart"] && !Shopify.designMode) return;
  try {
    const eeSizeCharts = new Map();
  const syncEeSizeCharts = () => {
    for (const [id, chart] of eeSizeCharts) {
      if (!chart.dialog.isConnected) eeSizeCharts.delete(id);
    }
    document.querySelectorAll('dialog.ee-size-chart').forEach((dialog) => {
      let chart = eeSizeCharts.get(dialog.id);
      if (!chart || chart.dialog !== dialog) {
        const trigger = document.querySelector(`[data-ee-chart-open="${CSS.escape(dialog.id)}"]`);
        const scope = dialog.closest('.product__form__holder');
        if (!trigger || !scope) return;
        chart = {dialog, trigger, scope, selector: dialog.closest('.selector-wrapper'), legend: trigger.parentElement};
        eeSizeCharts.set(dialog.id, chart);
        scope.append(dialog);
      }
      chart.swatchLabel = Array.from(chart.scope.querySelectorAll('.swatch-label-container')).find((label) =>
        label.querySelector('.swatch-option-name')?.textContent.trim() === dialog.dataset.eeOptionName
      );
      const destination = chart.swatchLabel || chart.legend;
      if (destination.isConnected && chart.trigger.parentElement !== destination) destination.append(chart.trigger);
    });
  };
  let eeSizeChartFrame;
  new MutationObserver(() => {
    if (eeSizeChartFrame) return;
    eeSizeChartFrame = requestAnimationFrame(() => {
      eeSizeChartFrame = null;
      syncEeSizeCharts();
    });
  }).observe(document.documentElement, {childList: true, subtree: true});
  syncEeSizeCharts();
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-ee-chart-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.eeChartOpen);
      if (!(dialog instanceof HTMLDialogElement)) return;
      const chart = eeSizeCharts.get(dialog.id);
      const appSelected = chart?.swatchLabel?.closest('fieldset')?.querySelector('[role="radio"][aria-checked="true"]');
      const nativeSelected = chart?.selector?.querySelector('input[data-single-option-selector]:checked, input[type="hidden"][data-single-option-selector]');
      const selectedValue = appSelected?.getAttribute('orig-value') || appSelected?.getAttribute('aria-label') || nativeSelected?.value;
      dialog.querySelectorAll('[data-ee-chart-size]').forEach((row) => {
        if (row.dataset.eeChartSize === selectedValue) row.setAttribute('aria-current', 'true');
        else row.removeAttribute('aria-current');
      });
      if (!dialog.open) dialog.showModal();
      return;
    }
    const close = event.target.closest('[data-ee-chart-close]');
    if (close) {
      close.closest('dialog.ee-size-chart')?.close();
      return;
    }
    if (event.target.matches('dialog.ee-size-chart')) {
      const dialog = event.target;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search-popdown"] && !Shopify.designMode) return;
  try {
    (() => {
  let pendingFrame = 0;

  function fitSearchPanels() {
    pendingFrame = 0;
    const viewport = window.visualViewport;
    const viewportBottom = viewport ? viewport.offsetTop + viewport.height : window.innerHeight;

    document.querySelectorAll('.theme__header header-search-popdown.is-open .search-popdown').forEach((panel) => {
      const bar = panel.querySelector('.search-popdown__main');
      if (!bar) return;
      const availableHeight = Math.max(0, Math.floor(viewportBottom - bar.getBoundingClientRect().bottom - 8));
      panel.style.setProperty('--am-search-panel-height', `${availableHeight}px`);
    });
  }

  function scheduleFit() {
    if (!pendingFrame) pendingFrame = window.requestAnimationFrame(fitSearchPanels);
  }

  document.addEventListener('toggle', (event) => {
    if (event.target.closest('header-search-popdown')) scheduleFit();
  }, true);
  document.addEventListener('transitionend', (event) => {
    if (event.target.matches('.theme__header .search-popdown')) scheduleFit();
  });
  document.addEventListener('input', (event) => {
    if (event.target.matches('.theme__header input[type="search"]')) scheduleFit();
  });
  document.addEventListener('shopify:section:load', scheduleFit);
  window.addEventListener('resize', scheduleFit, { passive: true });
  window.visualViewport?.addEventListener('resize', scheduleFit, { passive: true });
  window.visualViewport?.addEventListener('scroll', scheduleFit, { passive: true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["menu-collection-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('menu-collection-slider')) {
  customElements.define('menu-collection-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-menu-slider-track]');
      this.previous = this.querySelector('[data-menu-slider-previous]');
      this.next = this.querySelector('[data-menu-slider-next]');
      this.progress = this.querySelector('[data-menu-slider-progress]');
      if (!this.track || !this.previous || !this.next) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelector('[data-menu-slider-controls]').hidden = false;
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowRight' ? 1 : -1);
        }
      }, options);
      this.observer = new ResizeObserver(() => this.scheduleUpdate());
      this.observer.observe(this.track);
      this.scheduleUpdate();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.controller = null;
    }

    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      this.track.scrollBy({
        left: direction * step,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    }

    scheduleUpdate() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.max(0, this.track.scrollLeft);
        this.previous.disabled = position <= 1;
        this.next.disabled = position >= maximum - 1;
        const viewed = this.track.scrollWidth ? (position + this.track.clientWidth) / this.track.scrollWidth : 1;
        this.progress.style.width = Math.min(100, viewed * 100) + '%';
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
